import styled from 'styled-components'

const Container = styled.div`
  margin-bottom: ${props => (props.PDP_V2_FLAG ? '0' : '40px')};

  p {
    margin-bottom: 20px;

    &:last-of-type {
      margin-bottom: 0;
    }
  }

  ul:not(.product-documents) {
    list-style-type: disc;
    padding-left: 17px;
    margin: 10px 0;
  }

  hr {
    margin: 40px 0 50px;
  }
`

const Heading = styled.h2`
  padding-bottom: 10px;
  margin-bottom: 20px;
`

const AcordionHeader = styled.div`
  color: ${props => props.theme.color.palette['brand-1']};
`
const CategoryNumber = styled.div`
  p {
    padding-bottom: 10px;
  }
`

export { Container, Heading, AcordionHeader, CategoryNumber }
